import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
export const MetaPixel: React.FC<{
  pixelId: string;
}> = t0 => {
  const $ = _c(5);
  const {
    pixelId
  } = t0;
  if (!pixelId) {
    return null;
  }
  const t1 = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${pixelId}');
fbq('track', 'PageView');
`;
  let t2;
  if ($[0] !== t1) {
    t2 = <Script id="_next-meta-pixel" strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <noscript><img height="1" width="1" style={{
        display: "none"
      }} src="https://www.facebook.com/tr?id=1653852385549465&ev=PageView&noscript=1" /></noscript>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <>{t2}{t3}</>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};